/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Pill_Ai_WizardInputs */

const en_home_pill_ai_wizard = /** @type {(inputs: Home_Pill_Ai_WizardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI Camera Wizard`)
};

const es_home_pill_ai_wizard = /** @type {(inputs: Home_Pill_Ai_WizardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Asistente de cámara IA`)
};

const fr_home_pill_ai_wizard = /** @type {(inputs: Home_Pill_Ai_WizardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Assistant Caméra IA`)
};

const de_home_pill_ai_wizard = /** @type {(inputs: Home_Pill_Ai_WizardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`KI-Kamera-Assistent`)
};

const ja_home_pill_ai_wizard = /** @type {(inputs: Home_Pill_Ai_WizardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AIカメラウィザード`)
};

const zh_home_pill_ai_wizard = /** @type {(inputs: Home_Pill_Ai_WizardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI 相机向导`)
};

const ar_home_pill_ai_wizard = /** @type {(inputs: Home_Pill_Ai_WizardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مساعد الكاميرا بالذكاء الاصطناعي`)
};

const id_home_pill_ai_wizard = /** @type {(inputs: Home_Pill_Ai_WizardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kamera Wizard AI`)
};

const it_home_pill_ai_wizard = /** @type {(inputs: Home_Pill_Ai_WizardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Assistente Fotocamera IA`)
};

const ru_home_pill_ai_wizard = /** @type {(inputs: Home_Pill_Ai_WizardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ИИ Мастер Камеры`)
};

const pt_home_pill_ai_wizard = /** @type {(inputs: Home_Pill_Ai_WizardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Assistente de Câmera IA`)
};

const ko_home_pill_ai_wizard = /** @type {(inputs: Home_Pill_Ai_WizardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI 카메라 마법사`)
};

/**
* | output |
* | --- |
* | "AI Camera Wizard" |
*
* @param {Home_Pill_Ai_WizardInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const home_pill_ai_wizard = /** @type {((inputs?: Home_Pill_Ai_WizardInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Pill_Ai_WizardInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_home_pill_ai_wizard(inputs)
	if (locale === "es") return es_home_pill_ai_wizard(inputs)
	if (locale === "fr") return fr_home_pill_ai_wizard(inputs)
	if (locale === "de") return de_home_pill_ai_wizard(inputs)
	if (locale === "ja") return ja_home_pill_ai_wizard(inputs)
	if (locale === "zh") return zh_home_pill_ai_wizard(inputs)
	if (locale === "ar") return ar_home_pill_ai_wizard(inputs)
	if (locale === "id") return id_home_pill_ai_wizard(inputs)
	if (locale === "it") return it_home_pill_ai_wizard(inputs)
	if (locale === "ru") return ru_home_pill_ai_wizard(inputs)
	if (locale === "pt") return pt_home_pill_ai_wizard(inputs)
	return ko_home_pill_ai_wizard(inputs)
});